// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
import ReadinessChartController from "./readiness_chart_controller"
application.register("readiness-chart", ReadinessChartController)
import AnalyticsChartController from "./analytics_chart_controller"
application.register("analytics-chart", AnalyticsChartController)
import OperationalScopeController from "./operational_scope_controller"
application.register("operational-scope", OperationalScopeController)
import PasswordVisibilityController from "./password_visibility_controller"
application.register("password-visibility", PasswordVisibilityController)
